import React from "react";
import { PipePDFReportStyles } from "./pdfreport.stylesheet";
import { Document, Page, PDFViewer, Text, View, Image } from "@react-pdf/renderer";
import store from "../../store";
import pipeSelectors from "../../lib/pipe-selectors";
import {
    METRIC,
    IMPERIAL,
    PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID,
} from "../../lib/types";

const logoImg = require("../../media/PDFReport/ADS-email-logo.png");
const css = PipePDFReportStyles;

export default class pipesPdfReport extends React.Component{
    render() {
        const {
            lbl,
            unit,
            lang,
            user,
            content,
            pipeType,
            pipesCalc,
            projectInfo,
            pipeFitting,
            pipesTopCalc,
            projectDefault,
            porosityPercent,
        } = this.props;

        // const img = sectionImages[pipeType.id];
        /* The project object, if an instance(persisted is present), otherwise use the unsaved project info */
        const project = projectDefault || projectInfo;

        /* Full name */
        const fullName = user ? `${user.givenName} ${user.surname}` : "N/A";

        const formatNum = ( val ) => {
            return val && typeof val === "number"
                ? Number.isInteger(val) ? Math.floor(val) : val.toFixed(2)
                : val;
        };

        const renderPorosityPercent = () => {
            if (pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID) {
                return <View/>;
            } else {
                return ( <View style={css.rowView}>
                    <View style={css.innerLColView}>
                        <Text style={css.tableTextBold}>
                            {content[lang].stonePorosityPdf}
                        </Text>
                    </View>
                    <View style={css.innerRColView}>
                        <Text style={css.tableText}>
                            {formatNum(porosityPercent)}%
                        </Text>
                    </View>
                </View> );
            }
        };

        const convertUnits = ( value, unitType ) => {
            let unitValue = 0;
            switch (unit) {
                case METRIC:
                    switch (unitType) {
                        case "ft": // Feets to meters
                            unitValue = parseFloat(Math.round(( value * 0.3048 ) * 100) / 100).toFixed(2);
                            break;
                        case "in": // Inches to milimeters
                            unitValue = Math.round(Math.round(( value * 25.4 ) * 100) / 100);
                            break;
                        case "sf": //
                            unitValue = parseFloat(Math.round(( value / 10.764 ) * 100) / 100).toFixed(2);
                            break;
                        case "cf": // Cubic feets to cubic meters
                            unitValue = parseFloat(Math.round(( value / 35.315 ) * 100) / 100).toFixed(2);
                            break;
                        case "cy": // Cubic yards to cubic meters
                            unitValue = parseFloat(Math.round(( value / 1.308 ) * 100) / 100).toFixed(2);
                            break;
                        default:
                            unitValue = Math.round(value * 100) / 100;
                            break;
                    }
                    break;
                case IMPERIAL:
                    unitValue = formatNum(value);
                    break;
                default:
                    break;
            }
            return unitValue;
        };

        const state = store.getState();

        return (
            <PDFViewer style={css.viewer}>
                <Document
                    style={css.document}
                    onRender={this.handleOnRender}
                    title={content[lang].adsPdfReport}
                    author={content[lang].adsDesignTool}
                    creator={content[lang].adsDesignTool}
                    producer={content[lang].adsDesignTool}
                    subject={content[lang].adsCalculationsReport}
                    keywords={"ADS Design Tool, Advance Solutions, Report, PDF, Calculations"}
                >
                    <Page>
                        {/* Header image */}
                        <View style={css.headerView}>
                            <Image src={logoImg} style={css.logoImgStyle}/>
                        </View>
                        {/* <View style={css.rowView}>
              <View style={css.contentRowView}>
                <Text>
                  Thank you for using the ADS Cultec Design Tool.
                  This online tool produces a basic conceptual layout based on the inputs you provided and is not intended as a final design for construction.
                  Your local ADS representative is available to address any questions.{'\n\n'}

                  ADS has a full service Engineering Service Department that can review your project layout and provide specific detailed drawings to fit all the unique applications of each project.
                  Please contact the ADS Engineering Services department at 888-892-2694 or <Text style={css.links} href="#" target="_blank">ADSDesigntTool@ads-pipe.com</Text> for more specific guidance on your project.
                  The links below are for the Cultec Design Manual for each Chamber Type, the Cultec Incremental Storage spreadsheet and the Cultec Product Catalog.{'\n\n'}

                  <Text style={css.links} href="#" target="_blank">Cultec Product Catalog{'\n'}</Text>
                  <Text style={css.links} href="#" target="_blank">Cultec Incremental Storage Spreadsheet{'\n'}</Text>
                  <Text style={css.links} href="#" target="_blank">Cultec Design Manual{'\n\n'}</Text>

                  It is our intention to continuously improve the ADS Cultec Design Tool by adding additional features.
                  We welcome any feedback and appreciate your interest in Cultec and other ADS products.{'\n\n'}

                  Drawing Package: <Text style={css.links} href="#" target="_blank">download drawings for 'Murphy Oil Underdrain Test'{'\n'}</Text>
                  BOM Spreadsheet: <Text style={css.links} href="#" target="_blank">download BOM for 'Murphy Oil Underdrain Test'{'\n'}</Text>
                  (Note: This link will expire in 30 days.){'\n'}
                  (The DWG file is compatible with AutoCAD 2013 & above.){'\n\n'}
                </Text>
              </View>
            </View> */}
                        <View style={css.rowView}>
                            <View style={css.colView}>
                                {/* User inputs column */}
                                <Text style={css.titleText}>{content[lang].userInputs}</Text>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].projectName} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{project.projectName}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].state}: </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{project.state}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].city}: </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{project.city}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].engineer}: </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{fullName}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].measurementType} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{unit.charAt(0).toUpperCase() + unit.slice(1)}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].product} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{pipeType}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].nominalDiameter} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>{pipesCalc.pipeNominalDiameter._pipeND._inches}</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].requiredVolumePdf} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(pipesCalc.pipeRequiredVolume, "cf")} {lbl[unit].cubicFeet[lang]}.
                                        </Text>
                                    </View>
                                </View>
                                {/* Space */}
                                <Text> &nbsp; </Text>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].availableLengthPdf} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text
                                            style={css.tableText}>{convertUnits(pipesCalc.pipeAvailableLength, "ft")} {lbl[unit].ft[lang]}.</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].availableWidthPdf} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text
                                            style={css.tableText}>{convertUnits(pipesCalc.pipeAvailableWidth, "ft")} {lbl[unit].ft[lang]}.</Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>
                                            {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].pipeFillAbovePdf : content[lang].stoneAbovePdf}
                                        </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text
                                            style={css.tableText}>{convertUnits(pipesCalc.pipeStoneAbove, "in")} {lbl[unit].in[lang]}.</Text>
                                    </View>
                                </View><View style={css.rowView}>
                                <View style={css.innerLColView}>
                                    <Text style={css.tableTextBold}>
                                        {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].pipeBeddingBelowPdf : content[lang].stoneBelowPdf}
                                    </Text>
                                </View>
                                <View style={css.innerRColView}>
                                    <Text style={css.tableText}>{convertUnits(pipesCalc.pipeStoneBelow, "in")} {lbl[unit].in[lang]}.</Text>
                                </View>
                            </View>
                                {renderPorosityPercent()}
                            </View>
                            <View style={css.colView}>
                                {/* Results column */}
                                <Text style={css.titleText}>{content[lang].results}</Text>
                                {/* System volume and bed size
                <Text style={css.titleText}>System volume and bed size</Text> */}
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].installedStorageVolume}
                                        </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(pipesTopCalc.volume, "cf")} {lbl[unit].cubicFeet[lang]}.
                                        </Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].systemLengthPdf} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(pipesTopCalc.stoneBedDimensions.height.ft, "ft") || 0} {lbl[unit].ft[lang]}.
                                        </Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].systemWidthPdf} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(pipesTopCalc.stoneBedDimensions.width.ft, "ft") || 0} {lbl[unit].ft[lang]}.
                                        </Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].numberOfRows}: </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {pipesTopCalc.numberOfPipeRows}
                                        </Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>{content[lang].approxBedSizeRequired} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(pipesTopCalc.area, "sf") || 0} {lbl[unit].squareFeet[lang]}.
                                        </Text>
                                    </View>
                                </View>
                                {/* System components */}
                                <Text> &nbsp; </Text>
                                <Text style={css.titleText}>{content[lang].systemComponents}</Text>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>
                                            {pipeFitting._id !== PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID ? content[lang].amountOfFillRequired : content[lang].amountOfStoneRequired}
                                        </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(( pipeSelectors.pipeStoneBedAmount(state) / Math.pow(3, 3) ), "cy") || 0} {lbl[unit].cubicYard[lang]}
                                        </Text>
                                    </View>
                                </View>
                                <View style={css.rowView}>
                                    <View style={css.innerLColView}>
                                        <Text style={css.tableTextBold}>
                                            {content[lang].volumeOfExcavationPipes} </Text>
                                    </View>
                                    <View style={css.innerRColView}>
                                        <Text style={css.tableText}>
                                            {convertUnits(( pipeSelectors.pipeTotalExcavation(state) / Math.pow(3, 3) ), "cy") || 0} {lbl[unit].cubicYard[lang]}
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        {/* <View style={css.rowView}>
              <View style={css.contentRowView}>
                <View style={css.boldLetters}>
                  <Text>
                    {'\n\n'}Additional Notes: -The results for the System Components are general estimates and do not include consideration for waste.{'\n\n'}
                  </Text>
                  <View style={{textAlign: 'center'}}>
                    <Text>© Cultec 2019{'\n\n'}</Text>
                  </View>
                </View>
                <View style={{fontSize: 8}}>
                <Text>
                  NOTICE: This email message is intended only for the person or entity to which it is addressed.  This email message, including any attachments, may contain confidential and/or privileged
                  information and other materials, and is protected by copyright law.  Any unauthorized review, use, disclosure, or distribution is strictly prohibited.  If you are not the intended recipient, then please
                  contact the sender by reply email and delete/destroy all copies of the original email message and any attachments.  This email message, including any attachments, also may contain technical, or
                  similar types of, information and materials.  The sender does not make any express or implied representations or warranties with respect to such information and materials, including, without
                  limitation, fitness for a particular purpose or merchantability or as to the accuracy or completeness of any such information and materials, and any such representations and warranties are hereby expressly disclaimed.
                </Text>
                </View>
              </View>
            </View>
            <View style={css.contentView}>
              <Image style={css.sectionImgStyle} src={img} />
            </View> */}
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PipesPDF/pipePdfReport.component.js